import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=6d42bc05&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=6d42bc05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42bc05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d42bc05')) {
      api.createRecord('6d42bc05', component.options)
    } else {
      api.reload('6d42bc05', component.options)
    }
    module.hot.accept("./BaseAlert.vue?vue&type=template&id=6d42bc05&scoped=true&", function () {
      api.rerender('6d42bc05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/BaseAlert.vue"
export default component.exports